/*
 *  Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';

import { IOnFilterChangeParams } from '../components/Filters/Filter';

function isFilterEmpty(value: IOnFilterChangeParams): boolean {
    if (isObject(value)) {
        return filter(value, v => !isEmpty(v)).length === 0;
    }
    return isEmpty(value);
}

export default isFilterEmpty;
